/**
 * 星物语小店接口
 * - 商品列表 / 星裙币余额 / 购买结算 / 消费记录
 */
import request from './request'

/**
 * 商品列表（可按分类过滤）
 * @param {string} [category] 分类：裙装/配饰/袜子/鞋子/全部
 */
export function listProducts(category) {
  return request.get('/shop/list', { params: { category } })
}

/**
 * 查询账号当前星裙币余额
 * @param {string} no 账号
 */
export function getCoin(no) {
  return request.get('/shop/coin', { params: { no } })
}

/**
 * 购买结算
 * @param {{no: string, items: Array<{productId: number, count: number}>}} data
 */
export function buy(data) {
  return request.post('/shop/buy', data)
}

/**
 * 消费记录
 * @param {string} no 账号
 */
export function getOrders(no) {
  return request.get('/shop/orders', { params: { no } })
}
